<template>
  <div class="app-email-i">
    <div class="ae-list-w scrollable b-r">
      <div class="ael-head">
        <div class="actions-left">
        </div>
        <div class="actions-right">
          <a @click="getUsers">
            <i class="os-icon os-icon-grid-18"></i>
          </a>
          <a @click="formMode = 'add'">
            <i class="fal fa-plus"></i>
          </a>
        </div>
      </div>
      <div class="ae-list ps ps--theme_default ps--active-y users-list-w">
        <Loader v-if="loadingUsers" />
        <div class="ae-item with-status" :class="{'status-green': user.is_active == 1, 'status-red': user.is_active == 0}" v-for="user in users " @click="getUserDetails(user) ">
          <div class="aei-image ">
            <div class="user-avatar-w "><img alt=" " :src="user.avatar "></div>
          </div>
          <div class="aei-content " style="width: 100%; ">
            <div class="aei-timestamp ">@{{user.user_name}}</div>
            <h6 class="aei-title ">{{user.name}}</h6>
            <div class="aei-sub-title ">{{user.email}}</div>
            <div class="aei-text ">
              <a class="badge badge-primary " v-for="role in stringToArray(user.roles) ">{{role}}</a>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="ae-content-w scrollable ">
      <div class="aec-head ">
        <div class="actions-left ">
        </div>
        <div class="actions-right ">
        </div>
      </div>
      <div class="ae-content " style="width: 100% " v-if="selectedUser !=='' && formMode=='view' ">
        <div class="user-profile ">
          <div class="up-head-w ">
            <div class="up-main-info ">
              <div class="user-avatar-w ">
                <div class="up-header ">{{selectedUser.name}}</div>
              </div>

            </div>
          </div>
          <div class="up-controls" style="padding: 10px;">
            <div class="row ">
              <div class="col-lg-6 ">
                <div class="value-pair ">
                  <div class="label pr-5">Status:</div>
                  <div class="value badge badge-pill" :class="{'badge-success': selectedUser.is_active == 1, 'badge-danger': selectedUser.is_active == 0}">{{ selectedUser.is_active == 1 ? 'Active' : 'Inactive'}} </div>
                </div>
                <div class="value-pair ">
                  <div class="label ">Member Since:</div>
                  <div class="value ">{{selectedUser.created_at}}</div>
                </div>
              </div>
              <div class="col-lg-6 text-right ">

                <a class="btn btn-danger btn-sm text-white" v-if="selectedUser.is_active==1 " @click="updateUser(0) ">
                  <span>Deactivate</span>
                </a>

                <a class="btn btn-success btn-sm text-white" v-if="selectedUser.is_active==0 " @click="updateUser(1) ">
                  <span>Activate</span>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="element-box p-10 " v-if="formMode=='add' ">
        <form id="addUserForm">
          <h5 class="form-header ">Add User</h5>
          <div class="form-desc ">You can add a new user using this form</div>

          <div class="form-group row ">
            <label class="col-form-label col-sm-4 " for=" "> Avatar</label>
            <div class="col-sm-8 ">
              <input type="file" id="avatar" name="avatar ">
            </div>
          </div>

          <div class="form-group row ">
            <label class="col-form-label col-sm-4 " for=" "> Name</label>
            <div class="col-sm-8 "><input name="name" class="form-control " placeholder="Enter user name " type="text "></div>
          </div>
          <div class="form-group row ">
            <label class="col-sm-4 col-form-label " for=" "> Email</label>
            <div class="col-sm-8 "><input class="form-control " name="email" placeholder="User Email " type="text"></div>
          </div>
          <div class="form-group row ">
            <label class="col-sm-4 col-form-label ">Role</label>
            <div class="col-sm-8 ">
              <div class="form-check " v-for="role in roles ">
                <label class="form-check-label "><input class="form-check-input " name="id_role" type="radio" :value="role.id_role ">{{role.role_name_en}}</label>
              </div>

            </div>
          </div>
          <div class="form-group row ">
            <label class="col-sm-4 col-form-label ">Location</label>
            <div class="col-sm-8 ">
              <div class="form-check " v-for="location in locations ">
                <label class="form-check-label "><input class="form-check-input " name="id_client_location" type="radio" :value="location.id_client_location ">{{location.name_en}}</label>
              </div>

            </div>
          </div>
          <div class="form-buttons-w ">
            <button class="btn btn-primary " type="button" @click="addUser()"> Submit</button>
          </div>
        </form>
      </div>
    </div>
  </div>

</template>

<script>
import CommonFunctions from '@/mixins/common-functions.js'

import Loader from '@/components/common/Loader'

export default {
  mixins: [CommonFunctions],
  components: { Loader },

  data () {
    return {
      users: '',
      roles: '',
      locations: '',
      loadingUsers: true,
      selectedUser: '',
      formMode: 'view'
    }
  },

  mounted () {
    this.getUsers()
  },

  methods: {
    getUsers () {
      var self = this
      const url = '/orgdesk/users'

      self.loadingUsers = true
      this.$http
        .post(url, {
          dataType: 'json',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json'
          }
        })
        .then(function (response) {
          self.users = response.data.users
          self.roles = response.data.roles
          self.locations = response.data.locations
          self.loadingUsers = false
        })
        .catch(function (error) {
          self.loadingUsers = false
          self.$store.dispatch('updateToast', {
            text: error.response.data.error,
            show: true
          })
        })
    },

    addUser: function () {
      var self = this

      const url = '/orgdesk/user/add'

      var form = document.getElementById('addUserForm')
      let data = new FormData(form)

      this.$http
        .post(url, data, {
          dataType: 'json',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json'
          }
        })
        .then(function (response) {
          self.$store.dispatch('updateToast', {
            text: 'User created',
            show: true
          })
          self.getUsers()
          self.formMode = 'view'
        })
        .catch(function (error) {
          self.$store.dispatch('updateToast', {
            text:
              (error.response && error.response.data.error) ||
              'Something went wrong',
            show: true
          })
        })
    },

    updateUser: function (active) {
      var self = this

      const url = '/orgdesk/user/update'

      let data = {
        is_active: active,
        id_user: self.selectedUser.id_user
      }

      this.$http
        .post(url, data, {
          dataType: 'json',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json'
          }
        })
        .then(function (response) {
          self.$store.dispatch('updateToast', {
            text: 'User updated',
            show: true
          })
          self.selectedUser.is_active = active
          self.formMode = 'view'
        })
        .catch(function (error) {
          self.$store.dispatch('updateToast', {
            text:
              (error.response && error.response.data.error) ||
              'Something went wrong',
            show: true
          })
        })
    },

    getUserDetails (user) {
      this.selectedUser = user
      this.formMode = 'view'
    }
  }
}
</script>

<style scoped>
.aec-full-message-w .message-content {
  padding: 0px;
}
.property-single .property-info-w {
  padding: 0px;
}
.property-single .property-info-w .property-info-main {
  padding: 10px;
}
.property-single .property-info-w .property-section .property-section-body {
  padding: 10px 0px;
}
.ae-content {
  padding: 0px;
}
.badge {
  color: #fff !important;
  margin-right: 5px;
}
.deactivated {
  background-image: repeating-linear-gradient(
    45deg,
    #ffffff,
    #ffffff 10px,
    #f5f5f5 10px,
    #f3f3f3 20px
  );
}
.aei-timestamp {
  color: #000 !important;
}
.user-profile .up-head-w:before {
  background: #323c58;
  background: #323c58;
}
.user-profile .up-main-info .user-avatar-w .user-avatar {
  width: 60px;
  height: 60px;
  border-radius: 40px;
  border: 3px solid #fff;
  overflow: hidden;
  -webkit-box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.4);
  display: inline-block;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.4);
}
.user-profile .up-header {
  text-shadow: 1px 1px 3px rgba(0, 0, 0, 0.6);
  margin-left: 20px;
  color: #fff;
  font-size: 2.75rem;
  border-bottom: none;
  padding-bottom: 0px;
  display: inline-block;
  margin-bottom: 0px;
}

.user-profile .up-main-info {
  padding: 10px;
}

.value-pair {
    display: inline-block;
}

.value-pair .label {
    color: rgba(0, 0, 0, 0.4);
    font-size: 0.85rem;
    text-transform: uppercase;
    display: inline-block;
}

.value-pair .value {
    display: inline-block;
    font-size: 0.85rem;
    text-transform: uppercase;
}

.value-pair+.value-pair {
    margin-left: 10spx;
    padding-left: 10px;
    border-left: 1px solid rgba(0, 0, 0, 0.1);
}
</style>
